import cn from 'classnames';

import styles from 'styles/components/common/form.scss';

export const TextField = props => (
  <input type="text" {...props} className={`${styles.textField} ${props.className ? props.className : ''}`}/>
);

export const CheckoutCheckBox = props => {
  const classes = cn(
    'mdl-checkbox__input',
    {
      [props.className]: props.className
    }
  );
  return (
    <input type="checkbox" {...props} className={classes}/>
  );
};

export const Select = props => (
  <div className={styles.selectDiv}>
    <select {...props} className={`${styles.select} ${props.className ? props.className : ''}`} />
  </div>
);
